export const COMPANION_QUICK_ACTIONS_V2 = [
  {
    key: "understand",
    label: "Why do I feel this way?",
    prompt:
      "Explain why I may be feeling this physically and mentally based on the nervous-system state and other information I reported. Connect the body response, thoughts or emotions, and relevant context in normal language.",
  },
  {
    key: "explain",
    label: "Why does this help?",
    prompt:
      "Explain why today’s suggestion may help me. Tell me what my current pattern suggests, why this input and relative dose fit, and what I should notice afterward.",
  },
  {
    key: "workout",
    label: "Build today’s workout",
    prompt:
      "Build me a workout from today’s approved output matched to my nervous-system state and let me add it to my APOS calendar.",
  },
  {
    key: "schedule",
    label: "What is scheduled?",
    prompt: "What do I have scheduled next, how soon is it, and how should I approach it?",
  },
  {
    key: "moderate",
    label: "Give me a moderate option",
    prompt: "I do not want high output. Give me a familiar moderate option.",
  },
  {
    key: "no-exercise",
    label: "I do not want exercise",
    prompt: "I do not want to exercise. Use a sport or recreation option instead if one is appropriate.",
  },
  {
    key: "somatic",
    label: "Use a somatic option",
    prompt: "I do not want exercise or recreation. Give me a somatic or mobility option that fits the current nervous-system state.",
  },
  {
    key: "minimum",
    label: "Give me a lower-demand option",
    prompt: "Give me a minimum step: the lowest-demand state-matched option that still fits what I reported right now.",
  },
];
